import React from 'react';
import {Pane} from "evergreen-ui";
import {Header} from "providerapp/layouts/Header";
import {LeftNavbar} from "providerapp/layouts/LeftNavbar";

import { Footer } from '../../../providerapp/layouts/Footer';
import { ProviderSelectionModal } from 'providerapp/component/ProviderSelectionModal';
import { useApplicationIsInternalAuth } from 'common/component/ApplicationRootContext';
import { NotificationToaster } from 'common';

type ProviderLayoutProps = {
    header: React.ReactNode,
    content: React.ReactNode,
}
export const ProviderLayout = ({header, content}: ProviderLayoutProps) => {
    const isInternalAuth = useApplicationIsInternalAuth();
    const [showProviderSelectionModal, setShowProviderSelectionModal] = React.useState(false);
    return (
        <Pane height='100vh' display='flex' flexDirection='column'>
            <NotificationToaster/>
            <Header changeProvider={() => setShowProviderSelectionModal(true)}/>
            <Pane className='portal-layout-main' flexGrow={1} display='flex' overflow='hidden'>
                <LeftNavbar currentSelection='User Management'/>
                <Pane flexGrow={1}
                      display='flex'
                      flexDirection='column'
                      height="100%"
                      overflow="auto"
                      background='#F5F4F9'
                >
                    <Pane padding='16px' paddingTop='30px'>
                        {header}
                    </Pane>
                    <Pane className='border-2 border-gray-500 shadow rounded-lg'
                          background='white'
                          margin='20px'
                          padding='16px'
                          flexGrow={1}
                    >
                        {content}
                    </Pane>
                    <Footer/>
                </Pane>
            </Pane>
            {
                isInternalAuth && <ProviderSelectionModal visible={showProviderSelectionModal} onClose={() => setShowProviderSelectionModal(false)}/>
            }
        </Pane>
    );
}
